import React from 'react';

const Row = ({ className, children }) => {
  return <div className={`form-group-row ${className}`}>{children}</div>;
};

export default Row;
